import { ROLE_EMPLOYEE, ROLE_MANAGER } from '@spa/constants'
import { getRoleRights } from 'snap-redux/modules/memberships/utils'

export const canAccessMembership = (
  currentUser,
  currentMembership,
  accessedMembership
) => {
  const { atLeast } = getRoleRights(currentMembership)

  if (atLeast.owner) {
    return true
  }

  const membershipRole = accessedMembership && accessedMembership.role
  const isCurrentUser =
    accessedMembership &&
    (currentUser && currentUser.id) === accessedMembership.user_id

  const canSeeMemberPage =
    // Allow access to roles lowers than director for directors.
    (atLeast.director &&
      (membershipRole === ROLE_MANAGER || membershipRole === ROLE_EMPLOYEE)) ||
    // Allow access for own page.
    isCurrentUser ||
    // Allow manager to access employee's page only if the preference is set.
    (atLeast.manager &&
      currentMembership &&
      currentMembership.manager_can_edit_employees &&
      membershipRole === ROLE_EMPLOYEE)

  return Boolean(canSeeMemberPage)
}

export const canEditEmployees = currentMembership => {
  const { atLeast } = getRoleRights(currentMembership)

  const canManage =
    atLeast.director ||
    (atLeast.manager && currentMembership.manager_can_edit_employees)

  if (canManage) {
    return canManage
  }

  return false
}
